/* eslint-disable */

import React, { useState, useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import Api from "./Api";
import PARSE from "html-react-parser";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import clsxm from "../../context/clsxm";
import ApiNew from "./Api";

const api = new ApiNew();

export default function SSoft_Line_Services() {
  const activeLanguage = useSelector((state) => state.content.activeLanguage);
  const [sections, setSections] = useState([]);
  const [title, setTitle] = useState(null);
  const [listLine, setListLine] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const getSectionDetail = () => {
      api
        .getSectionDetail({ language: activeLanguage })
        .then((res) => {
          if (res === 200 || res.data) {
            setSections(res.data.results);
          }
        })
        .catch((err) => {
          console.log("~ err", err);
        });
    };

    getSectionDetail();
  }, [activeLanguage]);

  useEffect(() => {
    let switchCaseCompleted = 0;

    if (sections.length > 0) {
      const sec = sections[0]?.widgets;
      if (sec && sec.length !== 0) {
        sec.forEach((section, i) => {
          switch (i) {
            case 0: {
              setTitle(section?.widget_contents[0]);
              break;
            }
            case 1: {
              setListLine(section?.widget_contents);
              break;
            }
            default:
              break;
          }

          switchCaseCompleted++;
        });

        if (switchCaseCompleted === 2) {
          setLoaded(true);
        }
      }
    }
  }, [sections]);

  return loaded ? (
    <div className="w-full relative  bg-[#FAF8F5] py-[60px]">
      <div className=" section-container section-margin-x">
        {/* Section Title */}
        <h1 className="header-style-non-hero text-newDarkBlue text-center mb-12">
          {"Our Services" || title?.content}
        </h1>

        {/* Grid of Service Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {listLine?.map((line, index) => {
            const icon =
              line?.assets[0]?.file_small || line?.assets[0]?.file_medium; // fallback to medium if small not available
            const iconDesc = line?.assets[0]?.description || "Service Icon";
            const { article_language } = line;

            return (
              <div
                key={index}
                className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow duration-200 flex flex-col"
                style={{
                  minHeight: "280px", // Optional: keep uniform height for visual alignment
                }}
              >
                {/* Icon */}
                {icon && (
                  <div className="mb-4">
                    <img
                      src={icon}
                      alt={iconDesc}
                      className="w-12 h-12 sm:w-16 sm:h-16 object-contain"
                    />
                  </div>
                )}

                {/* Title & Description */}
                <div className="flex-grow">
                  <h2 className="content-header-style-non-hero mb-2">
                    {article_language?.title}
                  </h2>
                  <p className="content-subheader-style-non-hero">
                    {PARSE(article_language?.content)}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  ) : (
    <div className="section-container section-margin-x">
      <Skeleton
        width={"100%"}
        className=" lg:h-[373px] s:h-[600px] h-[700px]"
      />
    </div>
  );
}
